import { gql } from "@apollo/client";

export const UPDATE_ENTITY = gql`
  mutation UpdateEntity(
    $project: ProjectDataInput!
    $entity: String!
    $field: String!
    $value: JSON
  ) {
    updateEntity(
      project: $project
      entity: $entity
      field: $field
      value: $value
    )
  }
`;

export const FLUSH_PROJECT_FIELDS = gql`
  mutation FlushProjectFields($project: ProjectDataInput!) {
    flushProjectFields(project: $project)
  }
`;

export const VALIDATE_PROCESS_FIELDS_IMPORT = gql`
  mutation ValidateProcessFieldsImport($data: ProcessFieldsImportInput) {
    validateProcessFieldsImport(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      totalFields
      newFields
      existingFields
      fields {
        key
        label
        type
        validation
        source
        isNew
      }
      mappings {
        source
        canonical
      }
    }
  }
`;

export const EXECUTE_PROCESS_FIELDS_IMPORT = gql`
  mutation ExecuteProcessFieldsImport($data: ProcessFieldsImportInput) {
    executeProcessFieldsImport(data: $data) {
      success
      created
      updated
      skipped
      totalFields
      strategy
      errors {
        key
        params
      }
      fields {
        key
        label
        type
        validation
        source
        isNew
      }
    }
  }
`;

const fieldRegistry = {
  UPDATE_ENTITY,
  FLUSH_PROJECT_FIELDS,
  VALIDATE_PROCESS_FIELDS_IMPORT,
  EXECUTE_PROCESS_FIELDS_IMPORT,
};

export default fieldRegistry;
